// Identidad visual del Gobierno de la República de Honduras.
export default {
    light: {
      primary: "#203D89",   // azul institucional
      secondary: "#D29E4A", // dorado
      accent: "#D29E4A",
      error: "#F44336",
      warning: "#FF9800",
      success: "#4CAF50",
      info: "#2C55B8",
      textColor: "#1B2340",
      iconColor: "#37474F",
      grayBold: '#4a4a4a'
  }
};
